import { GridColDef } from "@mui/x-data-grid-premium";
import { IconButton, Box, Card, Grid } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import BloodSugarTraceExampleRows from "../model";
import ByzMuiEditButton from "src/components/core-components/mui/buttons/ByzMuiEditButton";
import { useTranslate } from "src/locales";
import BloodSugarTrace from "../create";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import abdominal from "../assets/abdominal.png";
import femoral from "../assets/femoral.png";
import deltoid from "../assets/deltoid.png";
import BaseMedCardList from "src/components/shared-components/medcard/BaseMedCardList";
//BKARADENIZ;453138;02042025; Kan Şeker Takibi Formu Yapıldı
const bloodSugarColumns: GridColDef[] = [
  { field: "date", headerName: "Tarih", flex: 1 },
  { field: "field1", headerName: "Alan 1", flex: 1 },
  { field: "field2", headerName: "Alan 2", flex: 1 },
  { field: "field3", headerName: "Alan 3", flex: 1 },
  { field: "field4", headerName: "Alan 4", flex: 1 },
  { field: "field5", headerName: "Alan 5", flex: 1 },
  {
    field: "update",
    headerName: "Güncelle",
    width: 150,
    renderCell(params) {
      return <ByzMuiEditButton link={`edit/${params.row.id}`} />;
    },
  },
  {
    field: "delete",
    headerName: "Sil",
    flex: 1,
    renderCell: (params) => (
      <IconButton onClick={() => console.log(params.row.id)}>
        <DeleteIcon color="error" />
      </IconButton>
    ),
  },
];

function BloodSugarTraceList() {
  const { t } = useTranslate();

  return (
    <BaseMedCardList
      rows={BloodSugarTraceExampleRows}
      columns={bloodSugarColumns}
      CreateComponent={BloodSugarTrace}
      title={t("blood-sugar-trace.title")}
    >
      <Card sx={{ p: 3, mt: 5 }}>
        <Box sx={{ padding: 4 }}>
          <Grid container spacing={3} justifyContent="center">
            <Grid item xs={12} sm={4}>
              <Box textAlign="center">
                <ByzMuiTypography
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                >
                  {t("blood-sugar-trace.list.abdominal-area-title")}
                </ByzMuiTypography>
                <Box
                  component="img"
                  src={abdominal}
                  alt="Abdominal Bölge"
                  sx={{ width: "100%", height: "auto" }}
                />
                <ByzMuiTypography variant="body2" textAlign={"left"}>
                  {t("blood-sugar-trace.list.abdominal-description")}
                </ByzMuiTypography>
              </Box>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Box textAlign="center">
                <ByzMuiTypography
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                >
                  {t("blood-sugar-trace.list.femoral-area-title")}
                </ByzMuiTypography>
                <Box
                  component="img"
                  src={femoral}
                  alt="Femoral Bölge"
                  sx={{ width: "100%", height: "auto" }}
                />
                <ByzMuiTypography variant="body2" textAlign={"left"}>
                  {t("blood-sugar-trace.list.femoral-area-description")}
                </ByzMuiTypography>
              </Box>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Box textAlign="center">
                <ByzMuiTypography
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                >
                  {t("blood-sugar-trace.list.deltoid-area-title")}
                </ByzMuiTypography>
                <Box
                  component="img"
                  src={deltoid}
                  alt="Deltoid Bölge"
                  sx={{ width: "100%", height: "auto" }}
                />
                <ByzMuiTypography variant="body2" textAlign={"left"}>
                  {t("blood-sugar-trace.list.deltoid-area-description")}
                </ByzMuiTypography>
              </Box>
            </Grid>
          </Grid>

          <Box mt={4}>
            <ByzMuiTypography fontSize={"12px"} fontWeight={400} textAlign={"left"}>
              {t("blood-sugar-trace.list.hipoglisemi")}
            </ByzMuiTypography>
            <ByzMuiTypography fontSize={"12px"} fontWeight={400} textAlign={"left"}>
              {t("blood-sugar-trace.list.lipohipertrofi")}
            </ByzMuiTypography>
            <ByzMuiTypography fontSize={"12px"} fontWeight={400} textAlign={"left"}>
              {t("blood-sugar-trace.list.lipoatrofi")}
            </ByzMuiTypography>
          </Box>
        </Box>
      </Card>
    </BaseMedCardList>
  );
}

export default BloodSugarTraceList;
